'use strict'

import $ from 'jquery'
import DirectoryService from '../endpoints/DirectoryService'
import DirectoryDataTableHelper from './DirectoryDataTableHelper'

/**
 * Create a dataTable to show the Address Types
 **/
function createDataTable (selector, typeId, division, state, sportCode) {
  let params = '?type=' + typeId
  if (division) params += '&division=' + division
  if (state) params += '&state=' + state
  if (sportCode) params += '&sportCode=' + sportCode

  let dataTable =
    $(selector).DataTable({
      ajax: {url: DirectoryService.getMemberListApiEndPoint() + params, dataSrc: ''},
      responsive: true,
      autoWidth: false,
      pageLength: 25,
      columns: DirectoryDataTableHelper.defineColumns(typeId, sportCode),
      order: DirectoryDataTableHelper.defineOrder(typeId),
      'language': {
        'emptyTable': 'No members found'
      }
    })

  return dataTable
}

export default class MemberListTable {
  constructor (tableSelector, typeId, division, state, sportCode) {
    this.tableSelector = tableSelector
    this.typeId = typeId
    this.division = division.length > 0 ? division : null
    this.state = state.length > 0 ? state : null
    this.sportCode = sportCode.length > 0 ? sportCode : null
    this.initialize()
  }

  initialize () {
    createDataTable(this.tableSelector, this.typeId, this.division, this.state, this.sportCode)
  }
}
